import { createStore, combineReducers, applyMiddleware } from 'redux';
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import login from './pages/Home/reducer';
import snackbar from './common/snackbar/reducer';
import loader from './common/loader/reducer';
import QrCode from '../src/pages/reducer';
// import thunk from 'redux-thunk';

const persistConfig = {
  key: 'root',
  storage,
}


const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

const reducer = combineReducers({
  snackbar,
  loader,
  login,
  QrCode,



});

const persistedReducer = persistReducer(persistConfig, reducer)
const configureStore = (initialState) => createStoreWithMiddleware(persistedReducer, initialState);
const store = configureStore();
let persistor = persistStore(store)
export default { store, persistor }

